import { Flex, Text, Center } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";

import { getUrlForLocalImage } from "utils";
import { SecurityData } from "./Security";

const SecurityCard = ({ security }: { security: SecurityData }) => {
  return (
    <Flex
      w="100%"
      h={{ base: "180px", md: "360px" }}
      p={{ base: "16px 24px", md: "48px" }}
      flexDir="column"
      bg="#1B443D"
      borderRadius={{ base: "24px", md: "36px" }}
      backgroundImage={`${getUrlForLocalImage(security.bgImg)}`}
      backgroundSize="cover"
    >
      <Flex justifyContent="space-between" gap="12px">
        <Flex flexDir="column" gap={{ base: "4px", md: "12px" }}>
          <Text
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight={{ base: "500", md: "700" }}
            lineHeight={{ base: "28px", md: "38px" }}
            color="#FFF"
          >
            {security.title}
          </Text>
          <Text
            fontSize={{ base: "12px", md: "14px" }}
            fontWeight={{ base: "400", md: "500" }}
            lineHeight={{ base: "14px", md: "20px" }}
            color="#D8F0F0"
          >
            {security.subTitle}
          </Text>
        </Flex>

        <Center
          w={{ base: "40px", md: "60px" }}
          h={{ base: "40px", md: "60px" }}
          bg="#FFF"
          _hover={{
            bg: "#D8F0F0",
          }}
          borderRadius="50%"
        >
          <BaseImage
            src="/assets/arrow.svg"
            height={25}
            width={25}
            alt="arrow"
          />
        </Center>
      </Flex>
    </Flex>
  );
};

export default SecurityCard;
